import { render, staticRenderFns } from "./GltfViewer.vue?vue&type=template&id=9e41aae4&scoped=true&"
import script from "./GltfViewer.vue?vue&type=script&lang=js&"
export * from "./GltfViewer.vue?vue&type=script&lang=js&"
import style0 from "./GltfViewer.vue?vue&type=style&index=0&id=9e41aae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e41aae4",
  null
  
)

component.options.__file = "GltfViewer.vue"
export default component.exports